<template>
    <div>
        <!-- Editar Sinalizador -->
        <div class="modal fade" id="editarLaudoSinalizadorModal" tabindex="-1" role="dialog" aria-labelledby="modelTitleId" aria-hidden="true">
            <div class="modal-dialog modal-lg" role="document">
                <div class="modal-content">
                    <div class="modal-header">
                        <h5 class="modal-title">Editar Sinalizador</h5>
                        <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                            <span aria-hidden="true">&times;</span>
                        </button>
                    </div>
                    <div class="modal-body" v-if="edicao_sinalizador">
                        <div v-if="edicao_sinalizador.id_atendimento" class="alert alert-info">
                            #{{ edicao_sinalizador.id_atendimento }}
                        </div>

                        <template v-for="(sinal, isx) in edicao_sinalizador.sinals">
                            <div class="form-row" v-if="sinal.fl_ativo" :key="isx">
                                <div class="col col-12 col-md-6">
                                    <az-input 
                                        sizing="sm"
                                        placeholder="Sinalizador..."
                                        type="select" 
                                        optionsMode="aql"
                                        service="sinalizadores.index"
                                        :optionsParm="{ ativos: true }"
                                        optionsData="id_sinalizador_atendimento"
                                        required
                                        :validate="validate"
                                        v-model="sinal.id_sinalizador_atendimento">
                                        <template v-slot:button-pre>
                                            <div class="input-group-prepend">
                                                <button type="button" class="btn btn-outline-danger" @click="sinal.fl_ativo = false">
                                                    <i class="fa fa-minus" aria-hidden="true"></i>
                                                </button>
                                            </div>
                                        </template>
                                    </az-input>
                                </div>

                                <div class="col col-12 col-md-6">
                                    <az-input 
                                        sizing="sm"
                                        placeholder="Observações..."
                                        v-model="sinal.st_obs">
                                    </az-input>
                                </div>
                            </div>
                        </template>

                        <button type="button" class="btn btn-outline-primary btn-sm mb-3" @click="incluir_sinalizador_laudo()">Incluir Sinalizador do Procedimento</button>

                        <div class="form-row">
                            <div class="col col-12">
                                <az-input 
                                    label="Sinalizador do Atendimento"
                                    placeholder="Nenhum..."
                                    type="select" 
                                    optionsMode="aql"
                                    service="sinalizadores.index"
                                    :optionsParm="{ ativos: true }"
                                    optionsData="id_sinalizador_atendimento"
                                    v-model="edicao_sinalizador.id_sinalizador_atendimento">
                                </az-input>
                            </div>
                        </div>
                    </div>
                    <div class="modal-footer">
                        <button type="button" class="btn btn-secondary" data-dismiss="modal">Cancelar</button>
                        <az-submit @click="atualizar_sinalizador()">Atualizar</az-submit>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import _ from 'lodash';
import $ from 'jquery';
import AzInput from '../../shared/forms/AzInput.vue';
import AzSubmit from '../../util/AzSubmit.vue';

export default {
    data() {
        return { 
            edicao_sinalizador: null,
            validate: true,
        }       
    },

    components: {
        AzInput,
        AzSubmit,
    },

    methods: { 
        incluir_sinalizador_laudo () { 
            this.edicao_sinalizador.sinals.push({ 
                id_laudo: this.edicao_sinalizador.id_laudo, 
                id_sinalizador_atendimento: "",
                fl_ativo: true, 
                st_obs: "", 
            });
        },

        abrir (laudo, marcacao) { 
            this.validate = false; 
            
            this.edicao_sinalizador = { 
                ..._.cloneDeep(marcacao),
                id_laudo: _.get(laudo, 'id_laudo'),
                sinals: _.get(laudo, 'sinals') ? _.cloneDeep(_.get(laudo, 'sinals')) : [],
            };

            $('#editarLaudoSinalizadorModal').modal('show');
        },

        atualizar_sinalizador () { 
            this.$util.atualizar (this, { 
                service: 'laudos',
                func: 'atualizar_sinalizador',
                dados: { 
                    id_marcacao: this.edicao_sinalizador.id_marcacao,
                    id_sinalizador_atendimento: this.edicao_sinalizador.id_sinalizador_atendimento,
                    id_laudo: this.edicao_sinalizador.id_laudo,
                    sinals: this.edicao_sinalizador.sinals,
                },
                toast: true, 
                modal: 'editarLaudoSinalizadorModal',
                callback: res => { 
                    if ( res && res.marcacao ) { 
                        this.$emit('refresh', res);

                        /*
                        this.atendimento.marcacao.sinalizador_atendimento = res.marcacao.sinalizador_atendimento;
                        this.atendimento.marcacao.id_sinalizador_atendimento = res.marcacao.id_sinalizador_atendimento;

                        if ( res.sinals ) { 
                            this.atp.laudo.sinals = res.sinals;
                        }
                        */
                    }

                    this.$nextTick(() => {
                        $('[data-toggle="tooltip"]').tooltip();
                    });
                }
            });
        },

    }

}
</script>
